import React from 'react';
import { FaRegThumbsDown, FaRegThumbsUp } from 'react-icons/fa';
import BadgeResposta from '../shared/BadgeResposta';
import './respostaSimNao.css';

const RespostaSimNao = ({
  respostas,
  editable = false,
  valorSelecionado = null,
  onChange,
}) => {
  const resposta = respostas?.[0];
  const valor = valorSelecionado || resposta?.resposta || 'PENDENTE';
  const valorNormalizado = String(valor).toUpperCase();
  const simAtivo = valorNormalizado === 'SIM';
  const naoAtivo = valorNormalizado === 'NÃO';

  return (
    <div className={`resp-bloco ${!resposta ? 'vazio' : ''}`}>
      <span className="resp-label">Resposta:</span>

      {editable ? (
        <div className="chk-resposta-botoes">
          <button
            type="button"
            className={`resposta-valor danger ${
              naoAtivo ? 'is-active' : 'is-inactive'
            }`}
            onClick={() => onChange?.('NÃO')}
            aria-pressed={naoAtivo}
          >
            <FaRegThumbsDown className="resposta-icone" />
            <span className="resposta-texto">NÃO</span>
          </button>
          <button
            type="button"
            className={`resposta-valor success ${
              simAtivo ? 'is-active' : 'is-inactive'
            }`}
            onClick={() => onChange?.('SIM')}
            aria-pressed={simAtivo}
          >
            <FaRegThumbsUp className="resposta-icone" />
            <span className="resposta-texto">SIM</span>
          </button>
        </div>
      ) : (
        <BadgeResposta valor={valor} />
      )}

      {/* {resposta && (
        <div className="resp-datas">
          <small>última atualização: {resposta.dataUltimaResposta}</small>
        </div>
      )} */}
    </div>
  );
};

export default RespostaSimNao;
